export default __webpack_public_path__ + "static/media/react2.1303c2b1.webp";